import { render, staticRenderFns } from "./referral-code.vue?vue&type=template&id=03439968&scoped=true"
import script from "./referral-code.vue?vue&type=script&lang=js"
export * from "./referral-code.vue?vue&type=script&lang=js"
import style0 from "./referral-code.vue?vue&type=style&index=0&id=03439968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03439968",
  null
  
)

export default component.exports